import { render, staticRenderFns } from "./TaskData.vue?vue&type=template&id=8a404eea&scoped=true"
import script from "./TaskData.vue?vue&type=script&lang=js"
export * from "./TaskData.vue?vue&type=script&lang=js"
import style0 from "./TaskData.vue?vue&type=style&index=0&id=8a404eea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a404eea",
  null
  
)

export default component.exports